import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="FarmiAssist" link="https://www.github.com/percy-riptide/FarmiAssist" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
An app made using react native expo for solving queries of farmers
    </ProjectCard>
    <ProjectCard title="html5up try-out" link="https://percy-riptide.github.io" bg="linear-gradient(to right, #c33764 0%, #1d2671 100%)" mdxType="ProjectCard">
A simple portfolio website made using html5up's massively template
    </ProjectCard>
    <ProjectCard title="GatsbyJS Starter" link="https://www.github.com/percy-riptide/gatsby-starter" bg="linear-gradient(to right, #43cea2 0%, #185a9d 100%)" mdxType="ProjectCard">
Super responsive one page portfolio using gatsby starters
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      